import { Select } from "chakra-react-select";
import { Text } from "@chakra-ui/react";
import React, { forwardRef } from "react";
/**
 * options [{label: string, value: string, colorScheme:string, variant}]
 * value: options
 * onChange: ([{value, label}]) => void
 */
const MultiSelect = ({ options, isMulti = true, value, onChange, isReadOnly, ...props }) => {
  const optionStyle = (provided, state) => ({
    // is this applied??
    ...provided,
    bg: "transparent",
    color: state.isFocused ? "darkTeal" : "gray.600",
    fontWeight: state.isFocused ? "bold" : "normal",
  });
  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      bg: "transparent",
      px: 2,
      cursor: "inherit",
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: "none",
    }),
    option: optionStyle,
    selectedOptionStyle: optionStyle,
  };
  if (isReadOnly) {
    const svalue = value ? (Array.isArray(value) ? value.map((v) => v.label || v).join(", ") : value.label) : "";
    return <Text>{svalue}</Text>;
  }
  // Handle issue: If the select is narrow, eg in a table, then the selected option can be displayed badly as a column of letters
  if (value && !Array.isArray(value)) value = [value];
  const toMinWidth = (label) => {
    if (typeof label !== "string") return null;
    if (label.length < 5) return null;
    return Math.min(label.length * 8, 200) + "px";
  };
  const valueWithStyle = value?.map((v) => ({
    ...v,
    label: <div style={{ minWidth: toMinWidth(v.label) }}>{v.label || v}</div>,
  }));
  
  return (
    <Select
      options={options}
      value={valueWithStyle}
      onChange={onChange}
      isReadOnly={isReadOnly}
      {...props}
      isMulti={isMulti}
      chakraStyles={customStyles}
    />
  );
};
//
// const fowardRefMultiSelect = React.forwardRef(MultiSelect);
// fowardRefMultiSelect.displayName = "MultiSelect"; // for easier debugging
// export default fowardRefMultiSelect;

export default MultiSelect;
